export default {
    commenting: 'Commenting',
};
